import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import dazuThousandHands from '../assets/dazu/dazu-thousand-hands.jpg';

const LoginPage = () => {
  const navigate = useNavigate();
  const { user, loading, login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await login({ username: username.trim(), password });
      navigate('/', { replace: true });
    } catch (loginError) {
      setError(loginError.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="auth-page auth-page--dazu">
      <div
        className="auth-page__backdrop"
        style={{ '--auth-bg-image': `url(${dazuThousandHands})` }}
      />
      <section className="auth-card auth-card--dazu">
        <div className="brand-hero brand-hero--auth">
          <h1>大足游戏馆</h1>
          <p className="brand-hero__author">by catthreew</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}

          <label>
            账号
            <input
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
              type="text"
            />
          </label>

          <label>
            密码
            <input
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              type="password"
            />
          </label>

          <button type="submit" disabled={submitting}>
            {submitting ? '登录中...' : '登录'}
          </button>
        </form>
      </section>
    </main>
  );
};

export default LoginPage;
